import { green, yellow } from "@material-ui/core/colors"
import { darken } from "@material-ui/core/styles"
import { getCurrentHost } from "../../utils/getHost"

const styles = theme => ({
  shootsSection: {
    display: "flex",
    padding: 32,
    width: "100%",
    backgroundColor: "#f8f8f8",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
      backgroundColor: "white",
    },
  },
  shootsSectionWrapper: {
    flexGrow: 1,
    display: "flex",
    flexWrap: "wrap",
    zIndex: 0,
  },
  loaderSectionWrapper: {
    flexGrow: 1,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  shootCardWrapper: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  actionCard: {
    maxWidth: 300,
    flexGrow: 0,
    flexShrink: 0,
    textAlign: "left",
  },
  toggleZoomWrapper: {
    position: "relative",
    height: 24,
    width: 24,
  },
  calendarToggleIcon: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  calendarToggleView: {
    marginRight: theme.spacing(1),
  },
  // statusIndicator: {
  //   backgroundColor: theme.palette.grey[500],
  //   width: 12,
  //   height: 12,
  //   borderRadius: 6,
  //   display: "inline-block",
  //   top: 1,
  //   position: "relative",
  // },
  // eventText: {
  //   color: "#000000"
  // },
  // openIndicator: {
  //   backgroundColor: "#c1e9d7",
  // },
  // bookedIndicator: {
  //   backgroundColor: "#d0d0d0",
  // },
  // wrappedIndicator: {
  //   backgroundColor: "#dcf0ae",
  // },
  // cancelledIndicator: {
  //   backgroundColor: "#d7d7d7",
  // },
  // billedIndicator: {
  //   backgroundColor: "#dbb9e4",
  // },
  firm: {
    backgroundColor: "#C1E9D7",
    overflow: "hidden",
  },
  standBy: {
    backgroundColor: "#FBE6AA",
    overflow: "hidden",
  },
  statusIndicator: {
    backgroundColor: theme.palette.grey[500],
    width: 12,
    height: 12,
    borderRadius: 6,
    display: "inline-block",
    top: 1,
    position: "relative",
  },
  eventText: {
    color: "#000000",
    textOverflow: "ellipsis",
  },
  openIndicator: {
    // backgroundColor: theme.palette.secondary.main,
    backgroundColor: "#D14848",
  },
  bookedIndicator: {
    backgroundColor:
      getCurrentHost() === "crewmama"
        ? "#0000008a"
        : darken(theme.palette.primary.main, 0.2),
  },
  wrappedIndicator: {
    backgroundColor: green[400],
  },
  cancelledIndicator: {
    backgroundColor: "#9e9e9e",
  },
  billedIndicator: {
    // backgroundColor: "#966dd3",
    backgroundColor: "#DBB9E4",
  },
  eventPopover: {
    pointerEvents: "none",
  },
  eventPopoverPaper: {
    padding: theme.spacing(1),
  },
  eventPopoverTitle: {
    fontSize: "0.8rem",
  },
  roleTitle: {
    fontSize: "0.6rem",
    color: theme.palette.grey[600],
  },
  placeWrapper: {
    display: "flex",
    alignItems: "center",
  },
  placeIcon: {
    width: "0.7em",
    marginLeft: -2,
  },
  placeName: {
    fontSize: 10,
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  sortChildrenWrapper: {
    marginRight: 32,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginRight: 0,
      justifyContent: "space-evenly",
    },
  },
  sortBy: {
    marginRight: 16,
    fontWeight: "600",
  },
  sortOption: {
    color: theme.palette.primary.dark,
    cursor: "pointer",
  },
  sortOptionDisabled: {
    color: theme.palette.grey[500],
    cursor: "not-allowed",
  },
  sortOptionWrapper: {
    display: "flex",
    marginRight: 16,
  },
  filterButton: {
    marginLeft: 8,
  },
  closeIcon: {
    color: theme.palette.primary.main,
    backgroundColor: "white",
  },
  closeAvatar: {
    backgroundColor: "white",
    border: `2px solid ${theme.palette.primary.main}`,
    cursor: "pointer",
  },
  selected: {
    fontWeight: "600",
  },
  unselected: {
    color: "grey",
  },
  filterSeperator: {
    width: 1,
    height: 40,
    backgroundColor: theme.palette.divider,
    margin: `0 ${theme.spacing(1)}px`,
  },
  dayHeaderFix: {
    "& .fc .fc-list-sticky .fc-list-day > *": {
      backgroundColor: theme.palette.primary.main,
    },
    "& div > a": {
      color: "black",
    },
  },
  dayCellFix: {
    "& div > div > a": {
      color: "black",
    },
  },
  popoverBlurDiv: {
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    position: "fixed",
    zIndex: 1,
  },
  customPopover: {
    zIndex: 2,
    background: "white",
    borderRadius: 4,
    position: "absolute",
    transition: "opacity 200ms ease-in-out",
    padding: 4,
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      backgroundColor: "#f8f8f8",
    },
  },
  circularPortrait: {
    position: "relative",
    width: "200px",
    height: "200px",
    overflow: "hidden",
    borderRadius: "50%",
    width: "1%",
    height: "auto",
    backgroundColor: "black",
  },
  listViewTitle: {
    padding: " 0 !important",
    border: "none !important",
    width: "600px",
    overflow: "hidden",
  },

  listViewLocation: {
    padding: " 0 !important",
    border: "none !important",
    width: "130px",
    overflow: "hidden",
  },
  listViewStatus: {
    padding: " 0 !important",
    border: "none !important",
    width: "130px",
    overflow: "hidden",
  },
  avatar: {
    verticalAlign: "middle",
    width: "25px",
    height: "25px",
    borderRadius: "50%",
    marginRight: "5px",
  },
  backgroundWhite: {
    backgroundColor: "#ffffff",
  },
  listViewHeading: {
    backgroundColor: theme.palette.primary.main,
  },
  legendButton: {
    backgroundColor: "#e5e5fa",
    boxShadow: "none",
    borderBox: "none",
  },
  addShootlegendButton: {
    position: "fixed",
    bottom: "83px",
    right: "20px",
    zIndex: 5,
  },
  controlIcon: {
    color: theme.palette.primary.main,
    "&:hover": {
      color: "white",
    },
  },
  outlineButton: {
    color: theme.palette.primary.main,
    marginLeft: "32px",
  },
  dateSelectOptions: {
    width: "150px",
  },
  arrowDown: {
    border: "solid black",
    borderWidth: "0 3px 3px 0",
    display: "inline-block",
    padding: "3px",
    transform: "rotate(45deg)",
  },
  accordion: {
    padding: " 0 !important",
    border: "none !important",
    width: "600px",
    overflow: "hidden",

    backgroundColor: "#eee",
    color: "#444",
    cursor: "pointer",
    // padding: 18px;
    // width: 100%;
    // text-align: left;
    // border: none;
    // outline: none;
    transition: "0.4s",
    "&:hover": {
      backgroundColor: "#ccc",
    },
  },
  panel: {
    padding: "0 18px",
    backgroundColor: "white",
    display: "none",
    overflow: "hidden",
  },
  displayNone: {
    display: "none",
  },
  collapseStyles: {
    width: "100%",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  collapseSummary: {
    justifyContent: "center",
    color: theme.palette.primary.main,
  },
  collapseSummaryRow: {
    justifyContent: "center",
    width: "100%",
  },
  collapseDetails: {
    justifyContent: "center",
    padding: 0,
  },
  collapseDetailsContainer: {
    justifyContent: "center",
  },
  activeCollapseOption: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  shootPopoverRow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #e0e0e0",
    padding: "10px",
    margin: 0,
  },
  openShootDetails: {
    display: "flex",
    justifyContent: "center",
    padding: "10px",
  },
  searchShootsAutocomplete: {
    minWidth: "220px",
    paddingLeft: "20px",
    noteLineText: {
      fontSize: "0.90rem",
      fontWeight: 600,
      paddingLeft: "20px",
    },
  },
  noteLineTextMob: {
    fontSize: "0.90rem",
    fontWeight: 600,
    paddingLeft: "20px",
    marginTop: "20px",
  },
  dialogPaper: {
    // width: "100%",
    maxWidth: "fit-content",
  },
  selectedDay: {
    fontWeight: "400",
  },
  unselectedDay: {
    color: "grey",
  },
  selectedOption: {
    color: theme.palette.primary.main,
  },
  searchMenuPaper: {
    width: 500,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    height: 350,
  },
  searchMenuItemPaper: {
    marginRight: [0, "!important"],
    marginBottom: theme.spacing(2),
    "&:last-of-type": {
      marginBottom: 0,
    },
  },
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
  },
})

export default styles
